<template>
  <svgicon
    :name="!hasStore ? 'Illustrative/Location' : 'Logos/' + translateStoreProfile"
    role="presentation"
    :original="true"
    :style="{width: `${size}rem`, height: `${size}rem`}"
  />
</template>

<script>
import '#/Illustrative/Location'
import '#/Logos/ICA'
import '#/Logos/ICA-Nara'
import '#/Logos/ICA-Supermarket'
import '#/Logos/ICA-Kvantum'
import '#/Logos/ICA-Maxi-Stormarknad'
export default {
  name: "StoreProfileLogo",
  props: {
    hasStore: {
      type: Boolean,
      default: false,
      required: true,
    },
    storeProfile: {
      type: Number,
      default: 0,
      required: true,
    },
    size: {
      type: Number,
      default: 3
    },
  },
  computed: {
    translateStoreProfile () {
      switch(this.storeProfile) {
        case 0: 
          return 'ICA'
        case 1: 
          return 'ICA-Nara'
        case 2:
          return 'ICA-Supermarket'
        case 3:
          return 'ICA-Kvantum'
        case 4: 
          return'ICA-Maxi-Stormarknad'
        default:
          return 'ICA'
      }
    },
  }
}
</script>